import { createFileRoute, redirect } from '@tanstack/react-router'
import { Layout } from '@/layout/layout'
import { Content } from '@/layout/content'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { UserInactivityLogoutContent } from '@/features/user-inactivity-manager/user-inactivity-logout-content'
import { getPlayerSession } from '@/features/player-session'

export const Route = createFileRoute('/inactivity-logout')({
  component: InactivityLogout,
  validateSearch: zodValidator(
    z.object({
      redirect_uri: z.string().optional(),
    }),
  ),
  beforeLoad: async ({ search }) => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      const url = search.redirect_uri ? new URL(search.redirect_uri) : null
      return redirect({
        to: url ? `${url.pathname}${url.search}${url.hash}` : '/',
      })
    }
  },
})

function InactivityLogout() {
  return (
    <Layout>
      <Content backgroundVariant="branded">
        <UserInactivityLogoutContent />
      </Content>
    </Layout>
  )
}
